!function (e, a) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = a() : "function" == typeof define && define.amd ? define(a) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.it = a());
}(this, function () {
  "use strict";

  return [{
    locale: "it",
    pluralRuleFunction: function pluralRuleFunction(e, a) {
      var t = !String(e).split(".")[1];
      return a ? 11 == e || 8 == e || 80 == e || 800 == e ? "many" : "other" : 1 == e && t ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "anno",
        relative: {
          0: "quest’anno",
          1: "anno prossimo",
          "-1": "anno scorso"
        },
        relativeTime: {
          future: {
            one: "tra {0} anno",
            other: "tra {0} anni"
          },
          past: {
            one: "{0} anno fa",
            other: "{0} anni fa"
          }
        }
      },
      "year-short": {
        displayName: "anno",
        relative: {
          0: "quest’anno",
          1: "anno prossimo",
          "-1": "anno scorso"
        },
        relativeTime: {
          future: {
            one: "tra {0} anno",
            other: "tra {0} anni"
          },
          past: {
            one: "{0} anno fa",
            other: "{0} anni fa"
          }
        }
      },
      month: {
        displayName: "mese",
        relative: {
          0: "questo mese",
          1: "mese prossimo",
          "-1": "mese scorso"
        },
        relativeTime: {
          future: {
            one: "tra {0} mese",
            other: "tra {0} mesi"
          },
          past: {
            one: "{0} mese fa",
            other: "{0} mesi fa"
          }
        }
      },
      "month-short": {
        displayName: "mese",
        relative: {
          0: "questo mese",
          1: "mese prossimo",
          "-1": "mese scorso"
        },
        relativeTime: {
          future: {
            one: "tra {0} mese",
            other: "tra {0} mesi"
          },
          past: {
            one: "{0} mese fa",
            other: "{0} mesi fa"
          }
        }
      },
      day: {
        displayName: "giorno",
        relative: {
          0: "oggi",
          1: "domani",
          2: "dopodomani",
          "-2": "l’altro ieri",
          "-1": "ieri"
        },
        relativeTime: {
          future: {
            one: "tra {0} giorno",
            other: "tra {0} giorni"
          },
          past: {
            one: "{0} giorno fa",
            other: "{0} giorni fa"
          }
        }
      },
      "day-short": {
        displayName: "g",
        relative: {
          0: "oggi",
          1: "domani",
          2: "dopodomani",
          "-2": "l’altro ieri",
          "-1": "ieri"
        },
        relativeTime: {
          future: {
            one: "tra {0} g",
            other: "tra {0} gg"
          },
          past: {
            one: "{0} g fa",
            other: "{0} gg fa"
          }
        }
      },
      hour: {
        displayName: "ora",
        relative: {
          0: "quest’ora"
        },
        relativeTime: {
          future: {
            one: "tra {0} ora",
            other: "tra {0} ore"
          },
          past: {
            one: "{0} ora fa",
            other: "{0} ore fa"
          }
        }
      },
      "hour-short": {
        displayName: "h.",
        relative: {
          0: "quest’ora"
        },
        relativeTime: {
          future: {
            one: "tra {0} h",
            other: "tra {0} h"
          },
          past: {
            one: "{0} h fa",
            other: "{0} h fa"
          }
        }
      },
      minute: {
        displayName: "minuto",
        relative: {
          0: "questo minuto"
        },
        relativeTime: {
          future: {
            one: "tra {0} minuto",
            other: "tra {0} minuti"
          },
          past: {
            one: "{0} minuto fa",
            other: "{0} minuti fa"
          }
        }
      },
      "minute-short": {
        displayName: "min",
        relative: {
          0: "questo minuto"
        },
        relativeTime: {
          future: {
            one: "tra {0} min",
            other: "tra {0} min"
          },
          past: {
            one: "{0} min fa",
            other: "{0} min fa"
          }
        }
      },
      second: {
        displayName: "secondo",
        relative: {
          0: "ora"
        },
        relativeTime: {
          future: {
            one: "tra {0} secondo",
            other: "tra {0} secondi"
          },
          past: {
            one: "{0} secondo fa",
            other: "{0} secondi fa"
          }
        }
      },
      "second-short": {
        displayName: "s",
        relative: {
          0: "ora"
        },
        relativeTime: {
          future: {
            one: "tra {0} s",
            other: "tra {0} sec."
          },
          past: {
            one: "{0} s fa",
            other: "{0} sec. fa"
          }
        }
      }
    }
  }, {
    locale: "it-CH",
    parentLocale: "it"
  }, {
    locale: "it-SM",
    parentLocale: "it"
  }, {
    locale: "it-VA",
    parentLocale: "it"
  }];
});